module.exports = __webpack_public_path__ + "img/i_love_you.9e25838d.png";